import React, { FunctionComponent } from 'react';
import { AgendaItemsDialog } from './AgendaItemsDialog';
import { ConfirmationDialog } from './ConfirmationDialog';
import { DeleteDialog } from './DeleteDialog';
import { MeetingFormDialog } from './MeetingFormDialog';
import { ScoreFormDialog } from './ScoreFormDialog';
import { SectionFormDialog } from './SectionFormDialog';
import { TaskFormDialog } from './TaskFormDialog';
import { UserFormDialog } from './UserFormDialog';
import { NodeDeleteDialog } from './NodeDeleteDialog';
import { NodeFormDialog } from './NodeFormDialog';
import { BoardFormDialog } from './BoardsDialogs/BoardFormDialog';
import { BoardListFormDialog } from './BoardsDialogs/BoardListFormDialog';
import { TrelloCardFormDialog } from './BoardsDialogs/TrelloCardFormDialog';
import { TrelloReplacementFormDialog } from './BoardsDialogs/TrelloReplacementFormDialog';
import { LabelFormDialog } from './LabelFormDialog';
import { SignUpFormDialog } from './SignUpFormDialog';
import { UserGroupFormDialog } from './UserGroupFormDialog';
import { PasswordGroupFormDialog } from './PasswordGroupFormDialog';
import { PasswordFormDialog } from './PasswordFormDialog';
import { ProjectFormDialog } from './ProjectFormDialog';
import { KpiNoteDialog } from './KpiNoteDialog';
import { AgendaFormDialog } from './AgendaFormDialog';
import { AgendaCustomFormDialog } from './AgendaCustomFormDialog';
import { WidgetsDialog } from './WidgetsDialog';
import { ForgotPasswordDialog } from './ForgotPasswordDialog';
import { QuartalFormDialog } from './QuartalFormDialog';
import { AgencyDescriptionDialog } from './AgencyDescriptionDialog';
import { AIPreviewDialog } from './AIPreviewDialog';
import { DBTaskFormDialog } from './DBTaskFormDialog';
import { MeetingAttendeesDialog } from './MeetingAttendeesDialog';
import { ActivityFormDialog } from './ActivityFormDialog';
import { MeetingShortcutDialog } from './MeetingShortcutAddFileDialog';
import { MeetingShortcutAddFolderDialog } from './MeetingShortcutAddFolderDialog';
import { MeetingShortcutDeleteFileDialog } from './MeetingShortcutDeleteFileDialog';
import { GoogleCalendarDialog } from './GoogleCalendarDialog';
import { MeetingFolderFormDialog } from './MeetingFolderFormDialog';
import { MeetingArchiveNoteFormDialog } from './MeetingArchiveNoteFormDialog';
import { NewUserFormDialog } from './NewUserFormDialog';
import { WorkspaceCreationDialog } from './WorkspaceCreationDialog';
import { AnnualAndPeriodsFormDialog } from './AnnualAndPeriodsFormDialog';
import { MeetingArchiveLinkFormDialog } from './MeetingArchiveLinkFormDialog';
import { MeetingTemplatesFormDialog } from './MeetingTemplatesDialog';
import { SendMessageToMembersDialog } from './SendMessageToMembersDialog';
import { WrikeFoldersDialog } from './WrikeFoldersDialog';
import { BoardExportOptionsDialog } from './BoardExportOptionsDialog';
import { CompanyToolsCategoryFormDialog } from './CompanyToolsCategoryFormDialog';
import { SupportDialog } from './SupportDialog';
import { AddPaymentMethodDialog } from './AddPaymentMethodDialog';

export const Dialogs: FunctionComponent = () => (
  <>
    <AnnualAndPeriodsFormDialog />
    <ConfirmationDialog />
    <DeleteDialog />
    <AddPaymentMethodDialog />
    <MeetingFormDialog />
    <MeetingFolderFormDialog />
    <UserFormDialog />
    <NewUserFormDialog />
    <TaskFormDialog />
    <AgendaItemsDialog />
    <ScoreFormDialog />
    <SectionFormDialog />
    <NodeFormDialog />
    <NodeDeleteDialog />
    <BoardFormDialog />
    <BoardListFormDialog />
    <TrelloCardFormDialog />
    <TrelloReplacementFormDialog />
    <LabelFormDialog />
    <SignUpFormDialog />
    <UserGroupFormDialog />
    <PasswordGroupFormDialog />
    <PasswordFormDialog />
    <ProjectFormDialog />
    <KpiNoteDialog />
    <AgendaFormDialog />
    <AgendaCustomFormDialog />
    <WidgetsDialog />
    <ForgotPasswordDialog />
    <QuartalFormDialog />
    <AgencyDescriptionDialog />
    <AIPreviewDialog />
    <DBTaskFormDialog />
    <MeetingAttendeesDialog />
    <ActivityFormDialog />
    <MeetingShortcutDialog />
    <MeetingShortcutAddFolderDialog />
    <MeetingShortcutDeleteFileDialog />
    <MeetingArchiveNoteFormDialog />
    <MeetingArchiveLinkFormDialog />
    <GoogleCalendarDialog />
    <WorkspaceCreationDialog />
    <MeetingTemplatesFormDialog />
    <SendMessageToMembersDialog />
    <WrikeFoldersDialog />
    <BoardExportOptionsDialog />
    <CompanyToolsCategoryFormDialog />
    <SupportDialog />
  </>
);
